module.exports = __webpack_public_path__ + "img/dgb.7302cb08.svg";